import React from 'react'
import styled from 'styled-components'

export type CoursesListProps = {
  children: React.ReactNode
}

export const StyledCoursesList = styled.div`
  max-width: ${props => props.theme.maxWidth};
  margin: auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  column-gap: 25px;
  row-gap: 25px;

  @media only screen and (max-width: 600px) {
    padding: 0 2rem 2rem;
  }
`

export const CourseList = ({ children }: CoursesListProps) => {
  return <StyledCoursesList>{children}</StyledCoursesList>
}
